<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1024"
    @click:outside="dialog = false"
  >
    <template #activator="{ props }">
      <v-btn color="grey-darken-3" variant="tonal" v-bind="props" class="ml-2"
        >Visualizar Implementação</v-btn
      >
    </template>
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          <span class="text-h5">Visualizar Implementação</span>
          <v-btn
            variant="plain"
            rounded="xl"
            prepend-icon="mdi-window-close"
            @click="dialog = false"
          ></v-btn>
        </div>
      </v-card-title>
      <v-table
        class="ma-8 usecase--table"
        style="background: transparent"
        fixed-header="true"
        density="comfortable"
        ><thead class="text-grey">
          <tr>
            <th class="text-left text-grey">Tarefa</th>
            <th
              style="border-left: thin solid #efefef"
              class="text-center text-grey"
            >
              Tipo Implementação
            </th>
            <th
              style="border-left: thin solid #efefef"
              class="text-center text-grey"
            >
              Prioridade
            </th>
            <th
              style="border-left: thin solid #efefef"
              class="text-Left text-grey"
            >
              Status da Tarefa
            </th>
            <th
              style="border-left: thin solid #efefef"
              class="rounded-te-lg text-left text-grey"
            >
              Story Points
            </th>
          </tr>
        </thead>
        <div class="split"></div>
        <tbody>
          <tr v-for="item in implementacoes" :key="item">
            <td class="text-left">
              <RouterLink
                :to="
                  '/sprints/backlog/' +
                  (item.tb_implementacao.tb_tarefa.tb_itembacklogsprint[0] !==
                  undefined
                    ? item.tb_implementacao.tb_tarefa.tb_itembacklogsprint[0]
                        .id_sprint
                    : null) +
                  '/tarefa/' +
                  item.tb_implementacao.tb_tarefa.id_tarefa
                "
                ><p class="text-decoration-underline">
                  {{ item.tb_implementacao.tb_tarefa.titulo }}
                </p></RouterLink
              >
            </td>
            <td style="border-left: thin solid #efefef" class="text-center">
              {{
                converterEnumParaTexto(item.tb_implementacao.tipo_implementacao)
              }}
            </td>
            <td style="border-left: thin solid #efefef" class="text-center">
              <PriorityTag
                :priority="item.tb_implementacao.tb_tarefa.prioridade"
              />
            </td>
            <td style="border-left: thin solid #efefef" class="text-left">
              <PriorityTag
                :priority="item.tb_implementacao.tb_tarefa.status_tarefa"
              />
            </td>
            <td style="border-left: thin solid #efefef" class="text-left">
              {{ item.tb_implementacao.tb_tarefa.storypoint }}
            </td>
          </tr>
          <tr>
            <td class="pl-10 text-left"></td>
            <td class="text-grey text-body-2 text-left"><UseCaseModal /></td>
            <td class="text-center"></td>
            <td class="text-left"></td>
            <td class="text-left"></td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <v-container
      v-if="this.isLoading"
      class="d-flex justify-center align-center"
    >
      <v-progress-circular class="text-center" indeterminate size="20" />
    </v-container>
  </v-dialog>
</template>
<script>
/**
 * @module VisualizarImplementacoes
 * @desc Modal que lista as tarefas de implementação relacionadas ao caso de uso
 * atual.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {Array.<Object>} [implementacoes=[]] - Array com os objetos que
 * representam as tarefas de implementação.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se as tarefas de
 * implementação estão sendo carregadas.
 */
import axios from 'axios';

import PriorityTag from '@/components/PriorityTag.vue';
import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  name: 'TabelaUseCases',
  components: {
    PriorityTag,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      implementacoes: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getImplementacoes(this.id);
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Formata as strings do enum;
     */
    converterEnumParaTexto(string) {
      /// PRIORIDADE
      if (string === 'URGENTE') {
        return 'Urgente';
      } else if (string === 'ALTA') {
        return 'Alta';
      } else if (string === 'MEDIA') {
        return 'Média';
      } else if (string === 'BAIXA') {
        return 'Baixa';
      }
      /// TIPO
      if (string === 'FUNCIONALIDADE') {
        return 'Funcionalidade';
      } else if (string === 'TESTE_AUTOMATIZADO') {
        return 'Teste automatizado';
      }
    },
    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// PRIORIDADE.
      if (string === 'Urgente') {
        return 'URGENTE';
      } else if (string === 'Alta') {
        return 'ALTA';
      } else if (string === 'Média') {
        return 'MEDIA';
      } else if (string === 'Baixa') {
        return 'BAIXA';
      }
      /// TIPO.
      if (string === 'Funcionalidade') {
        return 'FUNCIONALIDADE';
      } else if (string === 'Teste automatizado') {
        return 'TESTE_AUTOMATIZADO';
      }
    },
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para obter as tarefas de implementação
     * de um determinado caso de uso.
     *
     * @param {Number} id O id do caso de uso.
     */
    async getImplementacoes(id) {
      this.isLoading = true;
      axios
        .get(apiUrl + `/api/v1/implementacao/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.implementacoes = res.data.implementacoes;
          console.log(this.implementacoes);
          this.isLoading = false;
        })
        .catch((error) => console.log(error));
    },
  },
};

// #EFEFEF
// #F9F8F8
// #B6B6B6
// #004984
</script>

<style>
.usecase--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.usecase--table tbody tr {
  background-color: #fff;
}

.usecase--table a {
  text-decoration: none;
  color: black;
}

/* th:first-child {
  border-top-left-radius: 12px;
}
th:last-child {
  border-top-right-radius: 12px;
} */
</style>
